import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarAdmin,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t, // นำเข้าฟังก์ชัน t
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import { formatNumber } from "../../utils/formatting";

export default class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",

      modal_create: false,
      modal_update: false,
      count: 24,

      // Form States (Modal)
      uid: "",
      company_id: company?.id, // อิงตาม curl
      department_code: "",
      name: "",
      is_active: true,

      // Mock Data: User List
      data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count;
    loading(true);

    // จำลองการเรียก API
    let [result] = await Promise.all([ 
      GET("admin/departments", { page_size: 10, page: page, data_search: filter_search }),
    ]);

    if (result?.status) {
      data = result.data || [];
      count = result.pagination?.count || 0;
    }
    this.setState({ data: data || [], count: count || 0 });
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      department_code,
name,
is_active
    } = this.state;

    if (!department_code.trim()) {
      alert("", "warning", t("warning"), t("verify_department_code"));
      return;
    } else if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_department_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let body = {
        company_id,
        department_code,
        name,
        is_active: is_active === "Active" ? true : false,
      };

      let result = !uid
        ? await POST("admin/departments", body)
        : await PUT("admin/departments/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false });
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || "An error occurred.",
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
      if (
        await alert(
          "",
          "warning",
          t("delete_item"),
          t("delete_desc"),
          t("confirm"),
          t("cancel"),
        )
      ) {
        loading(true);
        let result = await DELETE("admin/departments/" + id, null);
        if (result?.status) {
          alert("#", "success");
          this.Get(1);
        } else {
          alert(
            "",
            "warning",
            t("warning"),
            result?.message || "An error occurred.",
          );
        }
        loading(false);
      }
    };

  render() {
    const {
      data,
      count,
      filter_search,
      modal_create,
      modal_update,

      department_code,
      name,
      is_active,
    } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header Section */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("department_management")}</h3>
              <div className="text-secondary text-14">
                {t("manage_departments_desc")}
              </div>
            </div>
          </div>

          {/* Main White Container */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            {/* Top Filter Toolbar */}
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex gap-2 flex-wrap">
                <div className="position-relative flex-grow-1" style={{ maxWidth: "350px" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">
                                  {"\uf002"}
                                </span>
                                <input
                                  type="text"
                                  className="form-control ps-5 wpx-350"
                                  placeholder={t("search_departments")}
                                  value={filter_search}
                                  onChange={(e) => this.setState({ filter_search: e.target.value })}
                                  onKeyDown={(e) => e.key === 'Enter' && this.Get(1)}
                                />
                              </div>
              </div>
              {can("departments.create") ? (
              <button
                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                onClick={() =>
                  this.setState({
                    modal_create: true,
                    uid: "",
                    department_code: "",
                    name: "",
                    is_active: "Active",
                  })
                }
              >
                <span className="me-2 text-16">+</span> {t("add_department")}
              </button>
              ) : null}
            </div>
          </div>
          <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
            {/* Users Table */}
            <div className="table-responsive">
              <table
                className="table table-hover align-middle mb-0"
                style={{ minWidth: "1000px" }}
              >
                <thead>
                  <tr className="text-dark fw-bold text-12 border-bottom border-light">
                    <th className="py-3 border-0 wpx-250">{t("department_code")}</th>
                    <th className="py-3 border-0 wpx-250">{t("department_name")}</th>
                    <th className="py-3 border-0 text-center wpx-100">
                      {t("status")}
                    </th>
                    <th className="py-3 border-0 text-center wpx-100">
                      {t("actions")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => (
                    <tr
                      key={idx}
                      className="border-bottom border-light bg-white"
                    >
                      <td>
                        <div className="text-secondary text-14">
                          {item.department_code}
                        </div>
                      </td>
                      <td>
                        <div className="text-secondary text-14">
                          {item.name}
                        </div>
                      </td>

                      {/* Status */}
                      <td className="text-center">
                        {item.is_active ? (
                          <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">
                            {t("active")}
                          </span>
                        ) : (
                          <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">
                            {t("inactive")}
                          </span>
                        )}
                      </td>

                      {/* Actions */}
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                                                    <ActionIconButton
                            label={can("departments.update") ? t("edit") : t("view")}
                            icon={can("departments.update") ? ACTION_ICONS.edit : ACTION_ICONS.view}
                            variant={can("departments.update") ? "warning" : "primary"}
                            onClick={() => {
                              this.setState({
                                modal_update: true,
                                uid: item.uid,
                                department_code: item.department_code || "",
                                name: item.name || "",
                                is_active: item.is_active ? "Active" : "Inactive",
                              })
                            }}
                          />
                          
                          {can("departments.delete") ? (
                          <ActionIconButton
                            label={t("delete")}
                            icon={ACTION_ICONS.delete}
                            variant="danger"
                            onClick={() => this.Delete(item.uid)}
                          />
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
            <div>
              {t("showing")} 1-{data.length} {t("of")} {formatNumber(count)}{" "}
              {t("users_count")}
            </div>
            <Pagination
              className="mb-0"
              count={Math.ceil(count / 10) || 1}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>

        {/* MODAL: ADD NEW USER */}
        <Modal
          show={modal_create || modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
          centered
          contentClassName="border-0 rounded-4  shadow-lg"
        >
          <Modal.Header
            className="border-bottom border-light px-4 py-3 bg-white"
            closeButton
          >
            <h5 className="fw-bold mb-0 text-dark">
              {modal_update ? t("edit_department") : t("add_new_department")}
            </h5>
          </Modal.Header>
          <Modal.Body
            className="p-4 bg-white"
            
          >
<fieldset disabled={this.state.modal_update && !can("departments.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
            <div className="row g-4">
              {/* Basic Information */}
              <div className="col-12">
                <small className="text-muted d-block mb-3">
                  {t("basic_info_desc")}
                </small>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">
                      {t("department_code")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={department_code}
                      onChange={(e) =>
                        this.setState({ department_code: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">
                      {t("name")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={name}
                      onChange={(e) => {
                        this.setState({ name: e.target.value });
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* Status */}
              <div className="col-12 mt-4 border-top pt-4">
                <h6 className="fw-bold mb-1 d-flex align-items-center">
                  <span className="icon text-primary me-2">{"\uf772"}</span>{" "}
                  {t("status")}
                </h6>
                <small className="text-muted d-block mb-3">
                  {t("status_desc")}
                </small>
                <div className="d-flex gap-4">
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="userStatus"
                      id="statusActive"
                      checked={is_active === "Active"}
                      onChange={() => this.setState({ is_active: "Active" })}
                    />
                    <label
                      className="form-check-label text-dark text-14 pointer"
                      htmlFor="statusActive"
                    >
                      {t("active")}
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="userStatus"
                      id="statusInactive"
                      checked={is_active === "Inactive"}
                      onChange={() => this.setState({ is_active: "Inactive" })}
                    />
                    <label
                      className="form-check-label text-dark text-14 pointer"
                      htmlFor="statusInactive"
                    >
                      {t("inactive")}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
</Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_create: false, modal_update: false})}
            >
              {t("cancel")}
            </button>
            {(!this.state.modal_update || can("departments.update")) ? <button
              className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
            </button> : null}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
